import {
  faGrid2Plus,
  faIdCard,
  faKey
} from '@fortawesome/pro-duotone-svg-icons'

import customConfig from 'customConfig'

const SETTING_FILTER_TYPE = {
  GENERAL: 'general',
  CONNECTED_ACCOUNTS: 'connectedAccounts',
  SECURITY: 'security'
}

const buildSettingsFilterOptions = ({ t, isExchangeEnabled }) => {
  return [
    {
      value: SETTING_FILTER_TYPE.GENERAL,
      label: t('settings.general'),
      icon: faIdCard
    },
    ...(isExchangeEnabled
      ? [
          {
            value: SETTING_FILTER_TYPE.CONNECTED_ACCOUNTS,
            label: t(customConfig.connectedAccountsLabel),
            icon: faGrid2Plus
          }
        ]
      : []),
    {
      value: SETTING_FILTER_TYPE.SECURITY,
      label: t('settings.security'),
      icon: faKey
    }
  ]
}

export { SETTING_FILTER_TYPE, buildSettingsFilterOptions }
